/* eslint-disable react/no-array-index-key */
import { IReview } from "api/interfaces/home/home.type";
import Slider from "component/design-system/carousel/Slider";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { READ_ALL_REVIEWS_URL } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import styles from "modules/home/home.module.scss";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { numberFormat } from "util/helper/numberFormat";
import CustomerReview from "../../../component/customer-review/customer-review.component";
import localStyles from "./testimonials.module.scss";

interface ITestimonialsProps {
  reviews: IReview[];
  tileWidth: number;
  showArrowOnHover?: boolean;
  showScrollOnHover?: boolean;
  className?: string;
  isOldReview?: boolean;
  translationFile?: string;
}
function Testimonials(props: ITestimonialsProps) {
  const {
    reviews, tileWidth, showArrowOnHover = false, showScrollOnHover = false,
    className = "", isOldReview = false, translationFile = "home",
  } = props;
  const { t } = useTranslation(translationFile);
  const { averageRating, totalReviewCount } = useSelector((store: RootState) => store.authenticationState);
  // const [loading, infoData] = useApiDataLoadOnce(getSitejabberBusinessInfoApi);
  const testimonialAltText = "Hear What Our Customers Say: Testimonials";

  if (!reviews) {
    return null;
  }

  if (!reviews.length) {
    return <span />;
  }
  return (
    <div className={`${localStyles.testimonials_container} ${className} `}>
      <>
        <div className="d-flex align-items-center justify-content-center">
          <PAText component="p" fontSize={FONT_SIZE[5]} className="m-0 p-r-5" bold>
            {t("Excellent")}
          </PAText>
          <PAImage
            width={180}
            height={45}
            alt={testimonialAltText}
            title={testimonialAltText}
            src={getRelativeImagePath("/images/public/sitejabber-review-4.6.webp")}
            className="p-r-20"
          />
          <Link
            href="https://www.google.com/search?q=partsavatar+mississauga&oq=partsavatar+mis&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyDQgBEC4YrwEYxwEYgAQyBggCEEUYOTIHCAMQABiABDIHCAQQABiABDIHCAUQABiABDIHCAYQABiABDIGCAcQRRg8qAIAsAIA&sourceid=chrome&ie=UTF-8#lrd=0x89d4d25e5de0fd57:0x3a54a7d133a39b9d,1,,,,"
            target="_blank"
            aria-label="BBB"
            title="BBB"
          >

            <PAImage
              width={120}
              height={45}
              src={getRelativeImagePath("/images/home/bbb-client-say.svg")}
              alt="BBB"
              title="BBB"
            />

          </Link>
        </div>
        <div className="d-flex align-items-center justify-content-center m-b-20">
          {/* <HideIf show={infoData?.overallRating && !loading}> */}
          <div className="d-flex align-items-center m-t-5">
            <PAText component="p" fontSize={FONT_SIZE[3]} className="m-0">
              {/* Manipulating 4.54 rating to show 4.6 */}
              {/* {`${t("rated")} ${Math.ceil(infoData?.overallRating * 10) / 10} ${t("stars")} | ${numberFormat(infoData?.totalReviews)}+ ${t("excellent_reviews_and_counting_on")}`} */}
              {`${t("rated")} ${averageRating} ${t("stars")} | ${numberFormat(totalReviewCount)}+ ${t("excellent_reviews_and_counting_on")}`}
            </PAText>
            <Link
              href={READ_ALL_REVIEWS_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className={`${styles.viewAll} pointer m-0`}
              title="PartsAvatar's Customer Testimonials"
            >

              <PAImage
                width={90}
                height={50}
                alt="Authentic Customer Testimonials at PartsAvatar"
                title="Authentic Customer Testimonials at PartsAvatar"
                src={getRelativeImagePath("/cms/pubicImages/images/google-review.webp")}
                className="p-r-5"
              />

            </Link>
          </div>
          {/* </HideIf> */}
        </div>
      </>

      <div className="row m-0 p-b-20">
        <div className="slider-wrapper col-md-12 col-xs-12 p-0">
          <Slider
            tileWidth={tileWidth}
            // autoplay
            showArrowOnHover={showArrowOnHover}
            showScrollOnHover={showScrollOnHover}
            itemStyle={{ backgroundColor: "transparent", border: "none" }}
            liClass={localStyles.testimonial_li}
          >
            {reviews.map((review) => (
              <CustomerReview
                key={review.reviewId}
                {...review}
                isOldReview={isOldReview}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
